/* eslint-disable functional/no-loop-statement */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { CatalogEntryCarousel } from '@/components/content/CatalogEntryRecommendation/parts/CatalogEntryCarousel';
import { Skeleton } from '@mui/material';

const cardSkeletonContainerMapper = (partNumbers: string[]) =>
	partNumbers.map((partNumber) => ({
		partNumber,
		card: <Skeleton variant="rectangular" width={290} height={440} />,
		a11y: { 'aria-label': undefined, 'aria-labelledby': partNumber },
	}));

export const CatalogEntryRecommendationSkeleton = ({
	withoutmargin,
}: {
	withoutmargin?: boolean;
}) => {
	const slides = cardSkeletonContainerMapper(new Array(15).fill('')).map(({ card }) => card);

	return <CatalogEntryCarousel slides={slides} id={'loading-more'} withoutmargin={withoutmargin} />;
};
